import React from 'react';

import Typography from '@mui/material/Typography';

import { fonts } from '../gatsby-theme-material-ui-top-layout/theme';

import styled from 'styled-components';

import Box from '@mui/material/Box';

import MultiCoinGraphic2 from '../img/multi-coin-graphic-2.svg';
import CoinbaseLogo from '../img/coinbase-logo.svg';

import {
  PROPY_SPACE_GREY_DARK,
  PROPY_BLACK,
} from '../utils';

const ZoneContainer = styled.div`
  width: 100%;
  overflow: hidden;
  display: flex;
  justify-content: center;
  align-items: center;
`

const Zone = styled.div`
  max-width: 1080px;
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-direction: ${props => props.mobile ? 'column' : 'row'};
`

const OverflowGraphicContainer = styled.div`
  max-width: ${props => props.mobile ? 'auto' : '500px'};
`

const TypographyContainer = styled.div`
  max-width: ${props => props.mobile ? '300px' : '500px'};
  margin-left: ${props => props.mobile ? 'auto' : '0px'};
  margin-right: ${props => props.mobile ? 'auto' : '0px'};
  margin-bottom: ${props => props.mobile ? props.theme.spacing(4) : '0px'};
  text-align: ${props => props.mobile ? 'center' : 'left'};
`

const TypographySpacer = styled.div`
  margin-top: ${props => props.theme.spacing(1.5)};
`

const CoinGraphic = styled(Box).withConfig({
  shouldComponentUpdate: true,
})`
  margin-top: ${props => props.mobile ? '4px' : '8px'}
  height: ${props => props.mobile ? '21px' : '30px'}
  width: ${props => props.mobile ? '119px' : '170px'}
  path {
    fill: #0052ff;
  }
`

const MultiCoinGraphicBox = styled(Box).withConfig({
  shouldComponentUpdate: true,
})`
  max-height: ${props => props.mobile ? '300px' : 'auto'};

  .coin-1-outline,
  .coin-1-outline-inner,
  .coin-1-currency-icon,
  .coin-2-outline,
  .coin-2-outline-inner,
  .coin-2-currency-icon,
  .coin-3-outline,
  .coin-3-outline-inner,
  .coin-3-currency-icon,
  .coin-4-outline,
  .coin-4-outline-inner,
  .coin-4-currency-icon
   {
    transform-origin: center;
    transform-box: fill-box;
    opacity: 0;
  }

  // First coin
  .coin-1-outline,
  .coin-1-outline-inner,
  .coin-1-currency-icon {
    animation: floatAndFadeMultiCoin 4s infinite ease-in-out, fadeIn 0.5s ease-out forwards;
    animation-delay: 0s, 0s;
  }

  // Second coin
  .coin-2-outline,
  .coin-2-outline-inner,
  .coin-2-currency-icon {
    animation: floatAndFadeMultiCoin 4s infinite ease-in-out, fadeIn 0.5s ease-out forwards;
    animation-delay: 1.3s, 0.3s;
  }

  // Third coin
  .coin-3-outline,
  .coin-3-outline-inner,
  .coin-3-currency-icon {
    animation: floatAndFadeMultiCoin 4s infinite ease-in-out, fadeIn 0.5s ease-out forwards;
    animation-delay: 2.6s, 0.6s;
  }

  .coin-4-outline,
  .coin-4-outline-inner,
  .coin-4-currency-icon {
    animation: floatAndFadeMultiCoin 4s infinite ease-in-out, fadeIn 0.5s ease-out forwards;
    animation-delay: 3.9s, 0.6s;
  }

  @keyframes floatAndFadeMultiCoin {
    0%, 100% {
      transform: translateY(0);
    }
    50% {
      transform: translateY(-10px);
    }
  }

  @keyframes fadeIn {
    0% {
      opacity: 0;
    }
    100% {
      opacity: 1;
    }
  }
`

const CoinbasePartnership = ({ 
  isConsideredMobile,
}) => {

  return (
    <ZoneContainer>
      <Zone mobile={isConsideredMobile}>
        <TypographyContainer mobile={isConsideredMobile}>
          <TypographySpacer>
            <Typography variant="h4" sx={{ fontFamily: fonts.spaceGrotesk, color: PROPY_BLACK, letterSpacing: '-0.01em', textAlign: isConsideredMobile ? 'center' : 'left', ...(isConsideredMobile && { fontSize: '24px', lineHeight: '24px' }) }}>Crypto Escrow with</Typography>
            <CoinGraphic
              component={CoinbaseLogo}
              mobile={isConsideredMobile}
            />
          </TypographySpacer>
          <TypographySpacer>
            <Typography sx={{ fontFamily: fonts.robotoMono, color: PROPY_SPACE_GREY_DARK, letterSpacing: '-0.01em', fontWeight: 300, textAlign: isConsideredMobile ? 'center' : 'left', ...(isConsideredMobile && { fontSize: '14px', lineHeight: '14px' }) }}>
              Minimize market volatility and tax risks with a compliant, streamlined process. In recent years, 12%+ of first-time home buyers used crypto for down payments.
            </Typography>
          </TypographySpacer>
        </TypographyContainer>
        <OverflowGraphicContainer mobile={isConsideredMobile}>
          <MultiCoinGraphicBox
            mobile={isConsideredMobile}
            component={MultiCoinGraphic2}
          />
        </OverflowGraphicContainer>
      </Zone>
    </ZoneContainer>
  );
};

export default CoinbasePartnership;